var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_22594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0H7.9998C6.90059 0 6 0.900293 6 2.0001V15.9999H18V2.0001C18 0.900293 17.0994 0 16.0002 0Z",
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 8C19.8294 8 19.6659 8.02941 19.5 8.05068V17.4998H4.5V8.05068C4.33412 8.02941 4.17182 8 4.0002 8C1.79133 8 0 9.79098 0 11.9999C0 13.4786 0.809707 14.7539 1.9998 15.4451V17.9999C1.9998 20.2088 3.79113 21.9998 6 21.9998V23.9999H7.9998V21.9998H16.0002V23.9999H18V21.9998C20.2089 21.9998 21.999 20.2088 22.0002 17.9999V15.4451C23.1903 14.7539 24 13.4786 24 11.9999C24 9.79098 22.2087 8 19.9998 8Z",
    fill: "#A046D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_22594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSeat);
export default __webpack_public_path__ + "static/media/openSeat.e736951eb8d1d67a1fa54ecc85d69f52.svg";
export { ForwardRef as ReactComponent };